// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../channels2022/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sns-link[data-v-18210e5b]:not(:hover){color:#484a56}.ui-dark .sns-link[data-v-18210e5b]:not(:hover){color:#b8b8bd}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
